export const getScrollContainer = (): Element | Window => {
  return window['scrollContainer'] || window;
};
export const getScrollContainerHeight = (): number => {
  return 'clientHeight' in window['scrollContainer'] ? window['scrollContainer'].clientHeight : window['scrollContainer'].innerHeight;
};
export const setScrollContainer = (container: Element): {
  ();
} => {
  if (container) {
    const originalContainer = window['scrollContainer'];
    window['scrollContainer'] = container;
    return () => {
      window['scrollContainer'] = originalContainer;
    };
  }
  return () => {};
};
export default (fn, duration = 400, durationDelay = 30) => {
  const {
    window
  } = global;
  const scrollContainer = getScrollContainer();
  if (window && fn && scrollContainer) {
    let start, maxDistance;
    const step = i => {
      let target = fn && fn();
      const timestamp = new Date().getTime();
      start = start == null ? timestamp : start;
      const progress = timestamp - start;
      const p = Math.min(1, progress / duration);
      const scrollY = 'scrollY' in scrollContainer ? scrollContainer.scrollY : scrollContainer.scrollTop;
      const scrollX = 'scrollX' in scrollContainer ? scrollContainer.scrollX : scrollContainer.scrollLeft;
      const clientHeight = 'clientHeight' in scrollContainer ? scrollContainer.clientHeight : scrollContainer.innerHeight;
      const scrollHeight = 'scrollHeight' in scrollContainer ? scrollContainer.scrollHeight : document.documentElement.scrollHeight;
      const maxScrollY = scrollHeight - clientHeight;
      target = Math.min(maxScrollY, target);
      try {
        if (typeof target === 'number') {
          if (maxDistance === undefined) {
            maxDistance = target - scrollY;
          }
          if (p < 1) {
            let newDistance = Math.max(Math.min(1, 0.1 / Math.sinh(0.7 * p + 0.09) - 0.12), 0);
            newDistance = Math[maxDistance > 0 ? 'floor' : 'ceil'](newDistance * maxDistance);
            if (Math.abs(newDistance) <= 2) {
              scrollContainer.scrollTo(scrollX, target);
              return;
            }
            scrollContainer.scrollTo(scrollX, target - newDistance);
            return;
          } else {
            scrollContainer.scrollTo(scrollX, target);
            return;
          }
        }
      } finally {
        if (progress < duration + durationDelay) {
          window.requestAnimationFrame(step);
        }
      }
    };
    const animationId = window.requestAnimationFrame(step);
    return () => {
      window.cancelAnimationFrame(animationId);
    };
  }
  return () => {};
};
export const getTopOf = (element: Element): number => {
  const scrollContainer = getScrollContainer();
  const scrollY = 'scrollY' in scrollContainer ? scrollContainer.scrollY : scrollContainer.scrollTop;
  const containerTop = 'scrollY' in scrollContainer ? 0 : scrollContainer.getBoundingClientRect().top;
  return (element?.getBoundingClientRect?.()?.top || 0) + scrollY - containerTop;
};